import { FormControl, FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import "./General.css";

export default function CheckboxComponent({ checked, setChecked }) {
 const handleChange = (event) => {
  setChecked(event.target.checked);
 };

 return (
  <FormControl className="checkbox" component="fieldset" variant="standard">
   <FormControlLabel
    control={
     <Checkbox
      className="checkbox"
      checked={checked}
      onChange={handleChange}
      name="compare"
     />
    }
    label="Compare two scenarios"
   />
  </FormControl>
 );
}
